<div class="event-dynamic-forms-container " [ngClass]="configCss" *ngIf="selectedEvent; else event_not_selected">
  <div class="revalidate-event" *ngIf="showValidateEvent()">
    {{reValidateMessage}}
  </div>
  <div class="event-dynamic-form-item"
       [ngClass]="{'event-form-half-width': formConfig?.formHalfWidth}"
       [ngStyle]="{'width': formConfig?.formWidth}"
       *ngFor="let formConfig of _eventFormConfigs; let i = index">
    <span class="top-panel titles">{{formConfig.title | stringTranslate}}</span>
    <gen-dynamic-form
      class="info-dynamic-form"
      [popupMode]="true"
      [formData]=""
      [disabledForced]="!isEditable"
      [formName]="formConfig.formId"
      [formConfig]="formConfig.formConfig"
      [editMode]="true"
      [formVertical]="true"
      [listenToDataChange]="true"
      [requiredMessage]="''"
      (validateChange)="validationArray[i] = $event"
      (formChange)="updateFormData($event, i)"
    ></gen-dynamic-form>
  </div>
</div>
<ng-template #event_not_selected>
  <section class="no-event-selected">{{'NO_EVENT_SELECTED' | translate}}</section>
</ng-template>
